import api from 'services/api';

export async function listInvitations(organizationId: string) {
  return api.get(`/api/dashboard/organizations/${organizationId}/invitations`);
}
